export default __webpack_public_path__ + "static/media/radio-deselected.b6bf8260.svg";